import _         from 'lodash'
import moment    from 'moment'
import Immutable from 'immutable'

import { formatDate, dateFormat } from 'alto-utils/lib/utils'

import CanteenRepository     from 'alto-react-canteen/lib/models'
import Menu                  from './menu'
import Canteen               from './canteen'
import Course                from './course'
import CourseGroup           from './course_group'
import CanteenMenuWithOrders from './canteen_menu_with_orders'
import DailyMenuWithOrders   from './daily_menu_with_orders'
import GroupMenuWithOrders   from './group_menu_with_orders'
import CourseMenuWithOrder   from './course_menu_with_order'

export default class MenuWithOrders extends Menu
  canteenMenuClass: CanteenMenuWithOrders
  dailyMenuClass:   DailyMenuWithOrders
  groupMenuClass:   GroupMenuWithOrders

  @_loadMeals: ({ backend, startDate, endDate, clientID }) ->
    repository = CanteenRepository.for(backend.baseUrl)
    relation   = repository.meals.with('canteen', 'course', 'course.group', 'orders')

    backend.requestWithAuth('GET', '/canteen/load_menu_with_orders', \
                    qs: { from_date: formatDate(startDate), to_date: formatDate(endDate) })
      .then (response) -> relation.deserializeMany(response)

  @_courseMenuFor: (canteen, date, course, meals) ->
    order      = meals.flatMap((meal) -> meal.associations.orders.entities()).first()
    mealNumber = (order and order.associations.meal.number) or null

    new CourseMenuWithOrder(canteen, date, course, meals, mealNumber, mealNumber)

  @_postprocessCourseMenus: (courseMenus, courses) ->
    @_processAdditionalCourses(courseMenus, courses)

  @_processAdditionalCourses: (courseMenus, courses) ->
    selectedMeals = GroupMenuWithOrders.selectedMeals(courseMenus)

    courseMenus
      .map (courseMenu, courseName) =>
        if courses.find(courseName).isAdditional
          if GroupMenuWithOrders.mealsWithAdditionalCourseExist(courseName, courseMenus)
            @_processAdditionalCourse(courseMenu, courseName, selectedMeals)
          else
            null # remove
        else
          courseMenu
      .filter (courseMenu) -> courseMenu # get rid of nulls

  @_processAdditionalCourse: (courseMenu, courseName, selectedMeals) ->
    selectedMainMeal = selectedMeals.find (meal) -> meal.additionalCourseName == courseName

    if selectedMainMeal
      if courseMenu.selectedMealNumber
        courseMenu
      else
        courseMenu.select(selectedMainMeal.additionalCourseDefaultNumber)
    else
      courseMenu.deselect()

  select: (newMeal) ->
    canteenID     = newMeal.canteenID
    course        = newMeal.associations.course
    acDefault     = newMeal.additionalCourseDefaultNumber
    formattedDate = formatDate(newMeal.date)
    lookupPath    = [canteenID, formattedDate, course.groupName, course.name]
    currentMeal   = @_canteenMenus.getIn(lookupPath).selectedMeal()
    canteenMenus  = @_canteenMenus.updateIn(lookupPath,
                                            (courseMenu) -> courseMenu.select(newMeal.number))

    if currentMeal?.hasAdditional()
      canteenMenus = canteenMenus.updateIn([canteenID, formattedDate,
                                            course.groupName, currentMeal.additionalCourseName],
                                           (courseMenu) -> courseMenu?.deselect())

    if newMeal.hasAdditional() and acDefault
      canteenMenus = canteenMenus.updateIn([canteenID, formattedDate,
                                            course.groupName, newMeal.additionalCourseName],
                                           (courseMenu) -> courseMenu?.safeSelect(acDefault))

    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  deselect: (canteenID, date, course) ->
    formattedDate = formatDate(date)
    lookupPath    = [canteenID, formattedDate, course.groupName, course.name]
    currentMeal   = @_canteenMenus.getIn(lookupPath).selectedMeal()
    canteenMenus  = @_canteenMenus.updateIn(lookupPath, (courseMenu) -> courseMenu.deselect())

    if currentMeal?.hasAdditional()
      canteenMenus = canteenMenus.updateIn([canteenID, formattedDate,
                                            course.groupName, currentMeal.additionalCourseName],
                                           (courseMenu) -> courseMenu?.deselect())

    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  save: (canteenID, date, group) ->
    canteenMenus = @_canteenMenus.updateIn([canteenID, formatDate(date), group.name],
                                           (courseMenus) ->
                                             courseMenus.map (courseMenu) -> courseMenu.save())

    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  cancel: (canteenID, date, group) ->
    canteenMenus = @_canteenMenus.updateIn([canteenID, formatDate(date), group.name],
                                           (courseMenus) ->
                                             courseMenus.map (courseMenu) -> courseMenu.cancel())

    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  groupMenusForCanteens: (date, group) ->
    @_canteenMenus
      .map (canteenMenu, canteenID) => @safeForGroup(canteenID, date, group)
      .filter(_.identity)

  canteenMenus: ->
    @_canteenMenus?.map(@_canteenMenuFor.bind(@)).valueSeq() or new Immutable.Seq

  isSaved: ->
    @_canteenMenusAreSaved(@_canteenMenus)

  otherCanteensAreSaved: (exceptCanteenID) ->
    @_canteenMenusAreSaved(@_canteenMenus.delete(exceptCanteenID))

  otherCanteensAndDatesAreSaved: (exceptCanteenID, exceptDate) ->
    @_canteenMenusAreSaved(@_canteenMenus.deleteIn([exceptCanteenID, formatDate(exceptDate)]))

  allAdditionalMealsSelected: ->
    @canteenMenus().every (canteenMenu) -> canteenMenu.allAdditionalMealsSelected()

  orders: ->
    menus = @_canteenMenus?.map(@_canteenMenuFor.bind(@)) or new Immutable.Map

    menus.filter((cm) -> not cm.isSaved()).map (cm) -> cm.orders()

  saveAll: ->
    canteenMenus = @_canteenMenus.map (dailyMenus) ->
      dailyMenus.map (groupMenus) ->
        groupMenus.map (courseMenus) ->
          courseMenus.map (courseMenu) ->
            courseMenu.save()

    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  _canteenMenusAreSaved: (canteenMenus) ->
    canteenMenus.every (dailyMenus) ->
      dailyMenus.every (groupMenus) ->
        groupMenus.every (courseMenus) ->
          courseMenus.every (courseMenu) ->
            courseMenu.isSaved()

  _canteenMenuFor: (dailyMenus, canteenID) ->
    canteen = @canteens.find(canteenID)

    new CanteenMenuWithOrders(canteen, dailyMenus, @)
